const navigationButtonStyles = {
    display: {base: 'none', md: 'inline-flex'},
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'whiteAlpha.600',
    backdropFilter: 'blur(5px)',
    w: '28px',
    h: '28px',
    p: '4px',
    borderRadius: 'none',
    transition: 'all 0.2s ease',

    _hover: {
        bg: 'whiteAlpha.800',
    },

    '&::after': {
        content: '""',
        display: 'flex',
        w: '20px',
        h: '20px',
        p: '5px 0px',
        justifyContent: 'center',
        alignItems: 'center',
    },
}

// Icon variants for navigation buttons
const navigationIcons = {
    next: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='12' viewBox='0 0 8 12' fill='none'%3E%3Cpath d='M1.5 11L6.5 6L1.5 1' stroke='%2325252B' stroke-width='0.833333' stroke-linecap='square'/%3E%3C/svg%3E") no-repeat center center/8px`,
    prev: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='12' viewBox='0 0 8 12' fill='none'%3E%3Cpath d='M6.5 1L1.5 6L6.5 11' stroke='%2325252B' stroke-width='0.833333' stroke-linecap='square'/%3E%3C/svg%3E") no-repeat center center/8px`
}

export default {
    baseStyle: {
        // Main Swiper Container
        w: '100%',
        position: 'relative',

        // Common navigation button styles
        '& .swiper-button-next, & .swiper-button-prev': {
            ...navigationButtonStyles,
            '&::after': {
                ...navigationButtonStyles['&::after'],
                bg: navigationIcons.next,
            },
        },

        '& .swiper-button-disabled': {
            display: 'none'
        },

        // Next button specific
        '& .swiper-button-next': {
            right: 0,
        },

        // Previous button specific
        '& .swiper-button-prev': {
            left: 0,
            '&::after': {
                bg: navigationIcons.prev,
            },
        },
    }
}
